export type Device = 'ios' | 'android';
export type NavigationApp = 'naver' | 'kakao' | 'tmap';
type DeepLinkGenerator = (
	slat: number,
	slng: number,
	elat: number,
	elng: number,
	name?: string,
) => string;

type DeepLinkMap = Record<Device, Record<NavigationApp, DeepLinkGenerator>>;

const generateNaverDeepLink: DeepLinkGenerator = (
	slat,
	slng,
	elat,
	elng,
	name,
) =>
	`route/car?slat=${slat}&slng=${slng}&dlat=${elat}&dlng=${elng}${name ? `&dname=${encodeURIComponent(name)}` : ''}&appname=${import.meta.env.VITE_APP_URL}`;
const generateKakaoDeepLink: DeepLinkGenerator = (slat, slng, elat, elng) =>
	`route?sp=${slat},${slng}&ep=${elat},${elng}&by=car`;
const generateTmapDeepLink: DeepLinkGenerator = (
	slat,
	slng,
	elat,
	elng,
	name,
) =>
	`route?starty=${slat}&startx=${slng}&goaly=${elat}&goalx=${elng}${name ? `&goalname=${encodeURIComponent(name)}` : ''}`;

const deepLinkGenerators: DeepLinkMap = {
	ios: {
		naver: (slat, slng, elat, elng, name) =>
			`nmap://${generateNaverDeepLink(slat, slng, elat, elng, name)}`,
		kakao: (slat, slng, elat, elng) =>
			`kakaomap://${generateKakaoDeepLink(slat, slng, elat, elng)}`,
		tmap: (slat, slng, elat, elng, name) =>
			`tmap://${generateTmapDeepLink(slat, slng, elat, elng, name)}`,
	},
	android: {
		naver: (slat, slng, elat, elng, name) =>
			`intent://${generateNaverDeepLink(slat, slng, elat, elng, name)}#Intent;scheme=nmap;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.nmap;end`,
		kakao: (slat, slng, elat, elng) =>
			`intent://${generateKakaoDeepLink(slat, slng, elat, elng)}#Intent;scheme=kakaomap;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=net.daum.android.map;end`,
		tmap: (slat, slng, elat, elng, name) =>
			`intent://${generateTmapDeepLink(slat, slng, elat, elng, name)}#Intent;scheme=tmap;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.skt.tmap.ku;end`,
	},
};

export default deepLinkGenerators;
